(function () {
  const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  // Mirrors Dawn's own cart section-swapping map.
  const SECTIONS = [
    { section: 'main-cart-items',  targetId: 'main-cart-items',  selector: '.js-contents' },
    { section: 'main-cart-footer', targetId: 'main-cart-footer', selector: '.js-contents' },
    { section: 'cart-icon-bubble', targetId: 'cart-icon-bubble', selector: '.shopify-section' },
    { section: 'cart-drawer',      targetId: 'CartDrawer',       selector: '.drawer__inner' },
  ];

  function activeSections() {
    return SECTIONS.filter((s) => document.getElementById(s.targetId));
  }

  async function post(path, payload) {
    const active = activeSections();
    payload.sections = active.map((s) => s.section).join(',');
    payload.sections_url = window.location.pathname;

    const res = await fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return { state: await res.json(), active };
  }

  function render({ state, active }) {
    if (!state.sections) return window.location.reload();
    active.forEach(({ section, targetId, selector }) => {
      const html = state.sections[section];
      const container = document.getElementById(targetId);
      if (!html || !container) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      const target = container.querySelector(selector) || container;
      target.innerHTML = parsed ? parsed.innerHTML : html;
    });
    document.dispatchEvent(new CustomEvent('cart-upsell:updated'));
  }

  const addItem = (id) => post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  const changeLine = (key, quantity) => post('/cart/change.js', { id: key, quantity: quantity });

  function lock(card) {
    card.classList.add('is-loading');
    card.querySelectorAll('input, button').forEach((el) => (el.disabled = true));
  }

  async function run(card, work) {
    lock(card);
    try {
      render(await work());
    } catch (err) {
      console.error('[cart-upsell]', err);
      window.location.reload();
    }
  }

  // Tick mark: add or remove
  document.addEventListener('change', (event) => {
    const input = event.target.closest('input[data-upsell-toggle]');
    if (!input) return;

    const card = input.closest('[data-cart-upsell]');
    if (!card) return;

    const lineKey = card.dataset.lineKey;
    run(card, () => (input.checked ? addItem(card.dataset.variantId) : changeLine(lineKey, 0)));
  });

  // Stepper: change quantity
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-upsell-step]');
    if (!button || button.disabled) return;

    const card = button.closest('[data-cart-upsell]');
    if (!card) return;

    event.preventDefault();

    const quantity = Number(card.dataset.quantity || 0);
    const lineKey = card.dataset.lineKey;
    const next = button.dataset.upsellStep === 'increase' ? quantity + 1 : Math.max(quantity - 1, 0);

    if (!lineKey) return run(card, () => addItem(card.dataset.variantId));
    run(card, () => changeLine(lineKey, next));
  });

  // Gift box removes itself when the cart no longer qualifies
  async function autoRemove() {
    const stale = document.querySelector('[data-gift-box-autoremove]');
    if (!stale || !stale.dataset.lineKey) return;
    stale.removeAttribute('data-gift-box-autoremove'); // guard against re-entry
    try {
      render(await changeLine(stale.dataset.lineKey, 0));
    } catch (err) {
      console.error('[cart-upsell]', err);
    }
  }

  document.addEventListener('DOMContentLoaded', autoRemove);
  document.addEventListener('cart-upsell:updated', autoRemove);
})();